
import config from '../config/config.json'
var ProdBaseUrl = "https://www.antenna.finder.backend.smaart-sesam.eu";


function WsLogin() {
    if (config.production) {
        return ProdBaseUrl+'/admin_authenticate';
    } else {
        return 'http://localhost:3083/admin_authenticate';
    }

}

function WsGetUsersList() {
    if (config.production) {
        return ProdBaseUrl+'/api/getAllUsers';
    } else {
        return 'http://localhost:3083/api/getAllUsers';
    }
}

function WsLogout() {
    if (config.production) {
        return ProdBaseUrl+'/logout';
    } else {
        return 'http://localhost:3083/logout';
    }
}

function WsGetMessagesByUser() {
    if (config.production) {
        return ProdBaseUrl+'/api/getMessagesByUser';
    } else {
        return 'http://localhost:3083/api/getMessagesByUser';
    }
}


function WsSendMessage() {
    if (config.production) {
        return ProdBaseUrl+'/api/sendMessage';
    } else {
        return 'http://localhost:3083/api/sendMessage';
    }
}

function WsGetAdminInfo() {
    if (config.production) {
        return ProdBaseUrl+'/api/getAdminInfo';
    } else {
        return 'http://localhost:3083/api/getAdminInfo';
    }
}

function WsGetDevicesList() {
    if (config.production) {
        return ProdBaseUrl+'/api/getAllDevices';
    } else {
        return 'http://localhost:3083/api/getAllDevices';
    }
}



export default { WsLogin, WsGetUsersList, WsGetMessagesByUser, WsSendMessage, WsGetAdminInfo, WsLogout, WsGetDevicesList }